/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

import { Fade } from 'react-awesome-reveal';
import Team from 'assets/images/hero/team.png';

import {
  ORG_NAME,
  ORG_MISSION,
  ORG_FOUNDER,
  ORG_FOUNDER_ROLE,
  ORG_FOUNDED_LABEL,
  ORG_ENTITY_TYPE,
  ORG_CHARTER_NUMBER,
  ORG_DOC_ID,
  ORG_ADDRESS_FULL,
  ORG_LOCALE,
  TAX_NOTICE,
} from '../constants';

const charterRows = [
  { label: 'Legal name', value: ORG_NAME },
  { label: 'Entity type', value: ORG_ENTITY_TYPE },
  { label: 'Ohio Charter #', value: ORG_CHARTER_NUMBER },
  { label: 'Document ID', value: ORG_DOC_ID },
  { label: 'Effective date', value: ORG_FOUNDED_LABEL },
  { label: 'Principal office', value: ORG_LOCALE },
  { label: 'Mailing address', value: ORG_ADDRESS_FULL },
];

export default class AboutPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <main id="main">

        {/* Hero */}
        <section className="hero sm:items-center lg:items-start sm:flex-row mb-12 lg:mb-20">
          <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
            <Fade direction="up" triggerOnce>
              <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3">
                Our story
              </p>
              <h1 className="text-5xl md:text-6xl text-theme-blue font-serif font-bold leading-tight mb-5">
                A Cleveland nonprofit, built for Mt. Pleasant.
              </h1>
            </Fade>
            <Fade direction="up" delay={300} triggerOnce>
              <p className="font-light text-xl text-gray-500 leading-relaxed">
                Founded in 2023 to invest in the next generation of Mt. Pleasant — through art, mentorship, and the steady work of self-discovery.
              </p>
            </Fade>
          </div>
          <div className="flex pt-5 w-full justify-center items-center order-first md:w-full lg:order-last lg:w-1/2">
            <Fade direction="top-right" triggerOnce delay={300}>
              <img src={Team} alt="Balance Point Studios" className="rounded-2xl" />
            </Fade>
          </div>
        </section>

        {/* Mission */}
        <section className="container mx-auto px-4 md:px-12 pb-12">
          <div className="max-w-4xl mx-auto space-y-12">
            <Fade direction="up" triggerOnce delay={300}>
              <div>
                <h2 className="text-3xl font-serif font-bold text-theme-blue mb-6">Our mission</h2>
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                  {ORG_MISSION}
                </p>
              </div>
            </Fade>

            <Fade direction="up" triggerOnce delay={400}>
              <div>
                <h2 className="text-3xl font-serif font-bold text-theme-blue mb-6">Why we exist</h2>
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                  We believe that creative self-expression is more than a hobby — it is a tool for self-discovery. When a young person finds their voice through music, paint, or performance, they begin to imagine a future they get to author themselves.
                </p>
                <p className="text-lg text-gray-500 font-light leading-relaxed mt-4">
                  That is the work we are here to do: to walk alongside Cleveland's young people as they redefine what is possible for their lives, their families, and their community.
                </p>
              </div>
            </Fade>

            {/* Founder */}
            <Fade direction="up" triggerOnce delay={500}>
              <div>
                <h2 className="text-3xl font-serif font-bold text-theme-blue mb-6">Founder</h2>
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                  Balance Point Studios was founded by{' '}
                  <strong className="text-theme-blue">{ORG_FOUNDER}</strong>
                  {' '}— {ORG_FOUNDER_ROLE} — who serves as the organization&apos;s statutory agent and is based in Cleveland.
                </p>
              </div>
            </Fade>

            {/* Charter card */}
            <Fade direction="up" triggerOnce delay={600}>
              <div>
                <h2 className="text-3xl font-serif font-bold text-theme-blue mb-6">Charter information</h2>
                <div className="rounded-2xl bg-white shadow-md border border-light-theme-purple overflow-hidden">
                  {charterRows.map((row, idx) => (
                    <div
                      key={row.label}
                      className={`flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 sm:gap-4 px-6 py-4 ${idx < charterRows.length - 1 ? 'border-b border-light-theme-purple' : ''}`}
                    >
                      <span className="text-gray-500 font-medium text-sm">{row.label}</span>
                      <span className="text-theme-blue font-medium text-right">{row.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Fade>

            {/* Tax notice */}
            <Fade direction="up" triggerOnce delay={700}>
              <div className="rounded-2xl border border-theme-gold bg-theme-gold/10 px-6 py-5">
                <p className="font-semibold text-theme-blue mb-1">Tax-exempt status notice</p>
                <p className="font-light text-theme-blue leading-relaxed text-sm md:text-base">
                  {TAX_NOTICE}
                </p>
              </div>
            </Fade>
          </div>
        </section>

        </main>
        <Footer />
      </>
    );
  }
}
